<template>
  <div class="batch-select-house">
    <a-row>
      <a-col>
        <a-row type="flex">
          <a-col class="w-auto h-auto"></a-col>
          <a-col class="h-auto" v-for="(value, index) in cols" :key="`col-${index}`">
            <a-checkbox :checked="value.checked" @change="changeCol(value, index)"></a-checkbox>
          </a-col>
        </a-row>
      </a-col>
      <a-col v-for="(value, index) in rows" :key="index">
        <a-row type="flex">
          <a-col class="w-auto">
            <a-checkbox :checked="value.checked" @change="changeRow(value, index)"></a-checkbox>
          </a-col>
          <a-col v-for="m in data[index]" :key="`data-${m.id}`">
            <a-row type="flex" justify="space-between" align="middle" class="panel">
              <a-col>{{m.alias}}</a-col>
              <a-col>
                <a-checkbox :checked="m.checked" @change="changeSingle(m)"></a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  export default {
    name: 'BatchSelectHouse',
    props: {
      initData: {
        type: Array,
        default: null
      },
      value: {
        type: Array,
        default: null
      }
    },
    data() {
      return {
        data: [],
        rows: [],
        cols: []
      }
    },
    watch: {
      initData: {
        handler(newValue, oldValue) {
          if (newValue) {
            let cols = 0;
            newValue.forEach(val => {
              val.forEach(m => {
                m.checked = false;
              });
              if (val.length > cols) {
                cols = val.length;
              }
            });
            this.data = this.$createNewVariable(newValue);
            this.rows = Array.from({
              length: newValue.length
            }, val => val = {
              checked: false
            });
            this.cols = Array.from({
              length: cols
            }, val => val = {
              checked: false
            });
          }
        },
        immediate: true
      },
      value: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.data.forEach(val => {
              val.forEach(m => {
                m.checked = newValue.map(x => x.id).indexOf(m.id) > -1;
              });
            });
            this.handleChecked();
          }
        },
        immediate: true
      }
    },
    methods: {
      changeCol(data, col) {
        this.data.forEach((val, index) => {
          if(val[col]) {
            val[col].checked = !data.checked;
          }
        });
        this.result();
      },
      changeRow(data, row) {
        if (this.data[row]) {
          this.data[row].forEach((val, index) => {
            val.checked = !data.checked;
          });
        }
        this.result();
      },
      changeSingle(data) {
        data.checked = !data.checked;
        this.result();
      },
      handleChecked() {
        this.rows.forEach((value, index) => {
          value.checked = this.data[index].filter(m => m.checked).length === this.data[index].length;
        });
        this.cols.forEach((value, index) => {
          let checked = true;
          this.data.forEach((m, n) => {
            if (m[index] && !m[index].checked) {
              checked = false;
            }
          });
          value.checked = checked;
        });
      },
      result() {
        let checkedResult = [];
        this.data.forEach(val => {
          let result = val.filter(m => m.checked); 
          if (result.length) {
            result.forEach(m => {
              if (checkedResult.map(x => x.id).indexOf(m.id) === -1) {
                checkedResult.push(m);
              }
            });
          }
        });
        this.handleChecked();
        this.$emit('input', checkedResult);
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .batch-select-house {
    overflow: auto;
    & > .ant-row {
      & > .ant-col {
        & > .ant-row-flex {
          flex-wrap: nowrap;
          & > .ant-col {
            flex-shrink: 0;
            width: 100px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: @padding-xs;
            min-width: 16px;
            min-height: 16px;
            &.w-auto {
              width: auto;
            }
            &.h-auto {
              height: auto;
            }
            .panel {
              width: 100%;
              height: 100%;
              background-color: @background-color-base;
              padding: @padding-xs @padding-md;
            }
          }
        }
      }
    }
  }
</style>